import getQueryParam from '@zola-helpers/client/dist/es/util/getQueryParam';

export const loginCallback = (): void => {
  const encodedReturnPath = getQueryParam('returnTo', true);

  // If a returnTo path is provided with a relative path, redirect there
  // Else go to the homepage for the normal redirect logic
  const returnToPath = decodeURIComponent(encodedReturnPath);
  const { protocol, host } = window.location;
  if (/^\//.test(returnToPath)) {
    window.location.assign(`${protocol}//${host + returnToPath}`);
  } else {
    window.location.assign('/');
  }
};
